<template>
  <div>
    <div style="background:#fff; padding:20px; margin-bottom:20px;">
      <a-select v-model="query.eventId" allow-clear placeholder="按赛事筛选统计" style="width:260px; margin-right:10px;">
        <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="loadData">刷新统计</a-button>
    </div>

    <div class="stat-grid">
      <div class="stat-card" v-for="item in statItems" :key="item.key">
        <div class="stat-title">{{ item.label }}</div>
        <div class="stat-value">{{ stats[item.key] || 0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDragonEventList, getDragonStatistics } from '@/api'

export default {
  data() {
    return {
      query: { eventId: undefined },
      eventOptions: [],
      stats: {},
      statItems: [
        { key: 'eventCount', label: '赛事数' },
        { key: 'teamCount', label: '队伍总数' },
        { key: 'approvedTeamCount', label: '已通过队伍' },
        { key: 'pendingTeamCount', label: '待审核队伍' },
        { key: 'memberCount', label: '已加入成员' },
        { key: 'pendingMemberCount', label: '待审核成员' },
        { key: 'registrationCount', label: '报名总数' },
        { key: 'approvedRegistrationCount', label: '已通过报名' },
        { key: 'pendingRegistrationCount', label: '待审核报名' },
        { key: 'publishedResultCount', label: '已发布成绩' }
      ]
    }
  },
  created() {
    this.loadEvents()
    this.loadData()
  },
  methods: {
    loadEvents() {
      getDragonEventList({ page: 1, pageSize: 200 }).then(res => {
        this.eventOptions = res.data.list || []
      })
    },
    loadData() {
      getDragonStatistics({ eventId: this.query.eventId }).then(res => {
        this.stats = res.data || {}
      })
    }
  }
}
</script>

<style scoped>
.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}
.stat-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.stat-title {
  color: #666;
  margin-bottom: 12px;
}
.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #13c2c2;
}
</style>
